export const memesUploadURL='https://jazzu-memes.as.r.appspot.com'
export const BUCKETS={
    UPLOADS:'jazzu-memes-upload',
    CHARACTERS:'memes_characters',
    PHOTOS:'memes_photos',
    ILLUSTRATIONS:'memes_illustrations',
    QUOTES:'memes_quotes',
    GRAPHICSEMPIRE:'memes_graphicsempire',
    CHARACTERS3D:'memes_3dcharacters'

}